'use strict'

/**
 * We can't accept ',' delimited CSV when uploading substance list to the batch (InChI can have ',' in it, so
 * it's not easy to auto-detect if it's a CSV or an InChI). So to be consistent between
 * both Export and Import it was decided to use ';' as a delimiter everywhere.
 *
 * @type {string}
 * @private
 */
const _VIZ_CSV_DELIMITER = ';';

class Array2CSV {
	convert(data) {
		if (!Array.isArray(data))
			throw new Error("Unsupported data format")
		const rows = [];
		for (const datum of data) {
			let cells = [];
			if (Array.isArray(datum))
				for (const next of datum)
					cells.push(new CsvCell(next))
			else cells = [new CsvCell(datum)]
			rows.push(new CsvRow(cells))
		}
		return new CsvFile(rows).toString();
	}
}

class CsvFile {

	/**
	 * @param {CsvRow[]} rows
	 */
	constructor(rows) {
		if (!Array.isArray(rows) || !rows.every(row => row instanceof CsvRow))
			throw new Error("Unsupported data type")
		this._rows = rows;
	}

	toString() {
		return this._rows.map(row => row.toString()).join("\r\n")
	}

	static fromString() {
		throw new Error("Not implemented");
	}
}

class CsvRow {
	/**
	 * @param {CsvCell[]} cells
	 */
	constructor(cells) {
		if (!Array.isArray(cells) || !cells.every(cell => cell instanceof CsvCell))
			throw new Error("Unsupported data type")
		this._cells = cells;
	}

	toString() {
		return this._cells.map(cell => cell.safeValue).join(_VIZ_CSV_DELIMITER)
	}
}

class CsvCell {
	/**
	 * @param {any} value
	 */
	constructor(value) {
		this._safeValue = CsvCell.transform(value);
	}

	get safeValue() {
		return this._safeValue;
	}

	static transform(value) {
		let str = (value === null || value === undefined) ? '' : `${value}`;
		str = str.replace(/"/g, "\"\"");
		if (str.includes(_VIZ_CSV_DELIMITER))
			str = `"${str}"`
		return str;
	}
}

export class CsvUtils {
	static array2CsvConverter = new Array2CSV();
}
